import { memo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Divider, List, Typography, useMediaQuery } from '@mui/material';

// project imports
import NavItem from './NavItem';
import menuItem, {getDynamicMenus} from 'menu-items';
import NavGroup from './NavGroup';
import useConfig from '../../../../hooks/useConfig';

import { useSelector } from 'react-redux';
import LAYOUT_CONST from '../../../../constant';
import { HORIZONTAL_MAX_ITEM } from '../../../MuiTheme/themeConfig';
import * as React from "react";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const theme = useTheme();
    const { layout } = useConfig();
    const { drawerOpen } = useSelector((state) => state.menu);
    const { applications, user } = useSelector((state) => state.account);
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    // last menu-item to show in horizontal menu bar
    const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

    const dynamicMenu = getDynamicMenus(applications);

    let lastItemIndex = dynamicMenu.items.length - 1;
    let remItems = [];
    let lastItemId;

    if (lastItem && lastItem < dynamicMenu.items.length) {
        lastItemId = dynamicMenu.items[lastItem - 1].id;
        lastItemIndex = lastItem - 1;
        remItems = dynamicMenu.items.slice(lastItem - 1, dynamicMenu.items.length).map((item) => ({
            title: item.title,
            elements: item.children,
            icon: item.icon,
            ...(item.url && {
                url: item.url
            })
        }));
    }

    const navItems = dynamicMenu.items.slice(0, lastItemIndex + 1).map((item) => {
        switch (item.type) {
            case 'group':

                if (item.url && item.id !== lastItemId) {
                    return (
                        <List
                            key={item.id}
                            {...(drawerOpen && layout !== LAYOUT_CONST.HORIZONTAL_LAYOUT && { sx: { m: 0, p: 0.1 } })}
                            disablePadding={!drawerOpen || layout === LAYOUT_CONST.HORIZONTAL_LAYOUT}
                        >
                            <NavItem item={item} level={1} isParents />
                            {layout !== LAYOUT_CONST.HORIZONTAL_LAYOUT && <Divider sx={{ pt: 0 }} />}
                        </List>
                    );
                }
                return <NavGroup key={item.id} item={item} lastItem={lastItem} remItems={remItems} lastItemId={lastItemId} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });


    const CustomMenu = () => {


        return <>
            {navItems}
        </>

    }

    return layout === LAYOUT_CONST.VERTICAL_LAYOUT || (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd) ? (
        <Box {...(drawerOpen && { sx: { mt: 0 } })}>{CustomMenu()}</Box>
    ) : (
        <>{CustomMenu()}</>
    );
};

export default memo(MenuList);
